import React from 'react';
import { Link } from 'react-router-dom';
import { experienceEntries, getEntryDate, getEntryTitle, getEntryLocation, getEntryDescription } from '../data/experience';
import LanguageSwitcher from '../components/LanguageSwitcher';
import { useLocale } from '../context/LocaleContext';
import { usePageMeta } from '../hooks/usePageMeta';
import '../components/experience/ExperienceWidget.css';
import './ResumePage.css';

const ResumePage: React.FC = () => {
  usePageMeta('Resume', 'Professional experience and work history.');
  const { t, locale, pathFor } = useLocale();

  return (
    <div className="resume-page">
      <div className="resume-top-bar">
        <Link to={`${pathFor('')}#experience`} className="resume-back-link">
          <span className="resume-back-arrow">←</span>
          {t('resume.backToHome')}
        </Link>
        <LanguageSwitcher />
      </div>
      <div className="resume-main">
        <header className="resume-header">
          <h1 className="resume-title">{t('resume.title')}</h1>
        </header>
        <div className="section-content">
          <div className="experience-list" role="list">
            {experienceEntries.map((entry) => (
              <div key={entry.id} className="experience-item" role="listitem">
                <div className="experience-header">
                  <div className="experience-date">{getEntryDate(entry, locale)}</div>
                  <div className="experience-content">
                    <h2 className="experience-title">
                      {getEntryTitle(entry, locale)} ·{' '}
                      <a
                        href={entry.companyUrl}
                        className="experience-company"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {entry.company}
                      </a>
                    </h2>
                    <p className="experience-location">{getEntryLocation(entry, locale)}</p>
                    <p className="experience-description">{getEntryDescription(entry, locale)}</p>
                    <ul className="experience-skills">
                      {entry.skills.map((skill) => (
                        <li key={skill}>{skill}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResumePage;
